import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Toggles = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

export const Languages = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px 24px;
`;

export const AliasRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px 14px;
    border: 1px solid ${colors.borderSoft};
    border-radius: ${radii.base};

    /* Гасим паддинг текстовой кнопки, чтобы подпись стояла по краю карточки. */
    & > button:last-child {
        margin-right: -8px;
    }
`;

export const AliasLink = styled.a`
    font-size: 0.9375rem;
    color: ${colors.primary};
    word-break: break-all;
`;

export const EmptyText = styled.p`
    margin: 0;
    font-size: 13px;
    color: ${colors.textSecondary};
`;

export const Preview = styled.p`
    margin: 0;
    font-size: 0.9375rem;
    color: ${colors.primary};
    word-break: break-all;
`;

export const Hint = styled.p`
    margin: 0;
    font-size: 12px;
    color: ${colors.textSecondary};
`;

export const InfoImageRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

/* Пропорцию не навязываем: поп-ап показывает картинку как есть. */
export const InfoImage = styled.img`
    max-width: 240px;
    max-height: 140px;
    object-fit: contain;
    border-radius: ${radii.base};
`;
